import DashboardUnreadsRenderer from "../admin/dashboard_unreads_renderer";
import TasksNotificationsRenderer from "../admin/tasks_notifications_renderer";

$(document).on("turbolinks:load", function () {
  if (!window.WebSocket) return;

  App.adminRoom = App.cable.subscriptions.create("AdminUserChannel", {
    initialized() {
      this.update = this.update.bind(this);
    },

    connected() {
      this.install();
      this.update();
    },

    disconnected() {
      console.log("Disconnected from the websocket.");
      this.uninstall();
    },

    update() {
      this.perform("get_unread_count");
    },

    // make sure to update when the users switches tabs/navigates
    install() {
      document.addEventListener("turbolinks:load", this.update);
      document.addEventListener("visibilitychange", this.update);
    },

    uninstall() {
      document.removeEventListener("turbolinks:load", this.update);
      document.removeEventListener("visibilitychange", this.update);
    },

    received(data) {
      switch (data.message_type) {
        case "unread_message_count":
          new DashboardUnreadsRenderer().refreshUnreadCount(data.message);
          break;
        case "tasks_counter":
          new TasksNotificationsRenderer().renderLabel(data.message);
          break;
        default:
          console.log(`unknown message type: ${data.message_type}`);
          break;
      }
    },
  });
});
